//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "id",
        descending: false,
      },
      warehouseColumn: [
        {
          name: "id",
          align: "left",
          label: "id",
          field: "id",
          style: "width: 20px",
          sortable: true,
        },

        {
          name: "warehouseName",
          align: "left",
          label: this.$t("stock.warehouse"),
          field: "warehouseName",
          sortable: true,
        },
      ],
      locationColumn: [
        {
          name: "id",
          align: "left",
          label: "id",
          field: "id",

          sortable: true,
        },

        {
          name: "warehouseName",
          align: "left",
          label: this.$t("stock.warehouse"),
          field: "warehouseName",
          sortable: true,
        },
        {
          name: "locationName",
          align: "left",
          label: this.$t("order.locationName"),
          field: "locationName",
          sortable: true,
        },
      ],
      UserSettings: [],
      CompanySettings: [],
      // Warehouses: [],
      // Locations: [],
      row: {},
      warehouseName: "",
      locationName: "",
      warehouseId: -1,

      promptLocation: false,
      promptWarehouse: false,
    };
  },

  mounted: function() {
    this.CompanySettings = this.companySettings;
    this.UserSettings = this.userSettings;
    // this.Warehouses = this.warehouses;
    // this.Locations = this.locations;
  },

  computed: {
    ...mapState("main", [
      "userSettings",
      "companySettings",
      "warehouses",
      "locations",
    ]),
  },

  methods: {
    async saveSettings() {
      var combinedSettings = this.UserSettings.concat(this.CompanySettings);
      var settingsToSave = [];

      combinedSettings.forEach((setting) => {
        var putSetting = {};
        putSetting.settingTypeId = setting.settingTypeId;
        putSetting.intValue = parseInt(setting.intValue);
        putSetting.stringValue = setting.stringValue;
        putSetting.boolValue = setting.boolValue;

        settingsToSave.push(putSetting);
      });

      await this.updateSettings(settingsToSave);
    },
    onCreateClickWarehouse() {
      this.row = {};
      this.warehouseName = "";
      this.promptWarehouse = true;
    },

    onCreateClickLocation() {
      this.row = {};
      this.locationName = "";
      this.warehouseName = "";
      this.promptLocation = true;
    },

    onRowClickWareHouse(evt, row) {
      this.row = row;
      this.warehouseName = row.warehouseName;
      this.promptWarehouse = true;

      console.log(row);
    },
    onRowClickLocation(evt, row) {
      this.row = row;
      this.locationName = row.locationName;
      this.warehouseId = row.warehouseId;
      this.promptLocation = true;

      console.log(row);
    },
    async createOrUpdateWarehouse() {
      var object = {};
      var result;
      try {
        if (this.row.id) {
          console.log("endre");
          object["warehouseName"] = this.warehouseName;
          object["isDeleted"] = false;
          object["id"] = this.row.id;
          console.log(object);
          result = await this.putWarehouse(object);
          console.log(result);
        } else {
          console.log("ny");
          object["warehouseName"] = this.warehouseName;
          object["isDeleted"] = false;
          result = await this.postWarehouse(object);
          console.log(result);
        }
        this.$notify({
          group: "foo",
          title: "",
          text: this.$t("common.saveOk"),
        });
      } catch (error) {
        console.log("error", error);
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: error,
          type: "error",
        });
      }
      this.getWarehouse();
    },
    async createOrUpdateLocation() {
      var object = {};
      var result;
      try {
        if (this.row.id) {
          console.log("endre");
          object["locationName"] = this.locationName;
          object["isDeleted"] = false;
          object["warehouseId"] = this.row.warehouseId;
          object["id"] = this.row.id;
          console.log(object);
          result = await this.putLocation(object);
          console.log(result);
        } else {
          console.log("ny");
          object["locationName"] = this.locationName;
          object["isDeleted"] = false;
          object["warehouseId"] = this.warehouseId;
          result = await this.postLocation(object);
          console.log(result);
        }
        this.$notify({
          group: "foo",
          title: "",
          text: this.$t("common.saveOk"),
        });
      } catch (error) {
        console.log("error", error);
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: error,
          type: "error",
        });
      }
      this.getLocation();
    },

    ...mapActions("main", [
      "getSettings",
      "updateSettings",
      "putWarehouse",
      "postWarehouse",
      "putLocation",
      "postLocation",
      "getLocation",
      "getWarehouse",
    ]),
  },
};
